export interface IBundleUpdate {
  appmarketBundleId: string;
  availableForInstall: boolean;
  availableForUpgrade: boolean;
  bundleName: string;
  bundleVersion: string;
  bundleVersionId: string;
  oneTimePrice: number;
  recurringPrice: number;
  sumAssignments: number;
  timeCreated: string;
}
